import axios from "axios";

export const sendCSV = async (Data) => {
  try {
    // Tell axios to treat response as a Blob
    const response = await axios.post("/splitt/api/csv", Data, {
      headers: {
        Accept: "multipart/form-data",
        "Content-Type": "multipart/form-data",
      },
      responseType: "blob",
    });

    // Extract filename from headers if present
    let filename = "file.csv";
    const disposition = response.headers["content-disposition"];
    if (disposition && disposition.indexOf("filename=") !== -1) {
      const match = disposition.match(/filename="?([^"]+)"?/);
      if (match) {
        filename = match[1];
      }
    }

    // Return the blob and filename!
    return { blob: response.data, filename };
  } catch (error) {
    console.error(error);
    return 0;
  }
};
